import React, { useState } from 'react';
import {
    API_RESPONSE,
    ApiStatus,
    ReducerInitialStates,
} from '../../../../contexts/ford-rides-context/ford-rides-context';
import { ReducerInitialState } from '../../../../models/ford-rides-trips-service-model';
import {
    ComponentType,
    RideType,
} from '../../../../views/ford-rides-view/ford-rides-view';
import { PrimaryButton } from '../../../common';
import { StringUtil } from '../../../utils/string-util/string-util';
import { FordRidesContentProps } from '../hooks/use-ford-rides-content';
import FordRidesAccordion from './ford-rides-accordion/ford-rides-accordion';
import './ford-rides-accordions.scss';
import { useAnalytics } from '../../../../hooks/use-analytics';

interface Props {
    state: ReducerInitialStates;
    accordionCategory: keyof ReducerInitialStates;
    setRideType: (data: RideType[]) => void;
    setView: (data: ComponentType) => void;
    apiStatus: ApiStatus;
    fordRidesData: FordRidesContentProps;
}

function FordRidesAccordions(props: Props) {
    const { state, accordionCategory } = props;
    const [tripId, setTripId] = useState('');
    const [fireEvents] = useAnalytics();
    function showRidesData() {
        fireEvents(
            ['ford-rides-view-all-cta'],
            undefined,
            {
                fieldName: accordionCategory,
            },
            false
        );
        props.setView(ComponentType.AllRides);
        props.setRideType([accordionCategory]);
    }
    return (
        <section className="ford-rides__list">
            <h3>
                {StringUtil.capitalizeFirstLetter(accordionCategory) +
                    ' ' +
                    '(' +
                    state[accordionCategory]?.length +
                    ` ${props.fordRidesData.ridesText})`}
            </h3>
            {!state[accordionCategory]?.length ? (
                <>
                    {[API_RESPONSE.FAILURE].includes(
                        props.apiStatus[`${accordionCategory}Status`]
                    ) ? (
                        <p className="list-error">
                            {props.fordRidesData.failureToFetchRide ||
                                'Something bad happened Please try again after sometime'}
                        </p>
                    ) : (
                        <p>
                            {props.fordRidesData.noRidesText ||
                                'No Ride Details Available for the selected Duration'}
                        </p>
                    )}
                </>
            ) : (
                <>
                    {state[accordionCategory]
                        ?.slice(
                            0,
                            parseInt(
                                props.fordRidesData.itemsPerSection as any
                            ) || 3
                        )
                        ?.map((accordionData: ReducerInitialState) => {
                            return (
                                <FordRidesAccordion
                                    {...accordionData}
                                    accordionCategory={accordionCategory}
                                    key={accordionData.tripRowId}
                                    tripId={tripId}
                                    setTripId={setTripId}
                                    fordRidesData={props.fordRidesData}
                                />
                            );
                        })}
                    <PrimaryButton
                        color="dark"
                        fill="fill"
                        chevron={true}
                        className="ride-type__selector"
                        onClick={showRidesData}
                    >
                        {props.fordRidesData.ridesCategoryCtaText || 'View All'}
                    </PrimaryButton>
                </>
            )}
        </section>
    );
}

export default FordRidesAccordions;
